import { translateLabel } from "@/i18n/messages";
export const emptyGroupedSearchResults = () => ({
  destinations: [],
  trails: [],
  places: [],
});

export const hasGroupedSearchResults = (results) => Boolean(
  results?.destinations?.length || results?.trails?.length || results?.places?.length
);

export const destinationTypeLabel = (type) => translateLabel(({
  BIKE_PARK: "Bike Park",
  TRAIL_CENTER: "Trail Center",
  RIDING_AREA: "Riding Area",
  STANDALONE_TRAIL: "Standalone Trail",
  OTHER: "Destination",
}[type] || "Destination"));
